module.exports = __webpack_public_path__ + "img/10-Insight Machinery Magazine.6ebea182.png";